import { IGetState, TBoardId } from '../../../types/types';
import { IRestAutoBackup } from '../types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { fetchHandler } from '../../../util/fetchHandler';
import { Util } from '../../../util/util';
import { REST_BOARD } from '../../constants';
import { getRestHeadersPost } from '../../helpers/getRestHeadersHelper';

export const postRest = (
    boardId: TBoardId,
    body: IRestAutoBackup
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IRestAutoBackup>(
            Util.getApiUrl(REST_BOARD + boardId + '/autobackups'),
            {
                ...getRestHeadersPost(),
                body: JSON.stringify(body)
            }
        ).then(response => {
            return response;
        });
    };
    return action;
};
